<template>
  <basic-container>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item label="中奖时间" prop="daterange">
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="奖品名称">
          <el-input placeholder="输入奖品名称或ID" v-model.trim="query.prize" clearable />
        </el-form-item>
        <el-form-item label="创建人">
          <el-input placeholder="输入操作人姓名" v-model.trim="query.createAt" clearable />
        </el-form-item>
        <el-form-item label="奖品类型" prop="status">
          <el-select v-model="query.type" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" :loading="loading"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="reset" :loading="loading"
            >清空</el-button
          >
          <el-button type="primary" icon="el-icon-plus" @click="add">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <yd-table
      :loading="loading"
      :data="records"
      border
      size="mini"
      :pagination="pagination"
      @onChange="onTableChange"
    >
      <el-table-column label="奖品ID" prop="id" align="center" />
      <el-table-column label="奖品名称" prop="prizeName" align="center" min-width="300" />
      <el-table-column label="奖品类型" prop="prizeType" align="center" width="200">
        <template slot-scope="scope">
          <div v-for="item in typeList" :key="item.value">{{
            scope.row.prizeType === item.value ? item.label : ''
          }}</div>
        </template>
      </el-table-column>
      <el-table-column label="价值" prop="price" align="center" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.price / 100 }}{{ scope.row.prizeType === 2 ? '元' : '' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUser" align="center" min-width="300" />
      <el-table-column label="创建时间" prop="createTime" align="center" width="300" />
      <el-table-column label="操作" prop="createUserName" align="center" width="80">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">编辑</el-button>
        </template>
      </el-table-column>
    </yd-table>

    <Edit v-if="editShow" :visible="editShow" :formData="editData" @close="editClose" />
  </basic-container>
</template>

<script>
  import Edit from './components/prize-pool-edit.vue'
  import { postPrizesPage } from '@/api/marketing/pirze-draw'
  export default {
    name: 'winningRecordTable',
    components: {
      Edit
    },
    data() {
      return {
        editData: {},
        editShow: false,
        typeList: [
          { value: 1, label: '优惠券' },
          { value: 2, label: '现金红包' },
          { value: 5, label: '礼包' }
        ],
        query: {},
        daterange: [],
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        records: [],
        loading: false
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
      editClose() {
        this.editShow = false
        this.editData = {}
        this.initPage()
      },
      add() {
        this.editShow = true
        this.editData = {}
      },

      handleEdit(v) {
        this.editShow = true
        if (v.prizeType === 2) {
          v.price = v.price / 100
        }
        this.editData = v
      },

      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.initPage()
      },

      search() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0] + ' 00:00:00'
          endTime = this.daterange[1] + ' 23:59:59'
        }
        this.pagination = {
          current: 1,
          size: 10,
          total: 0,
          startTime,
          endTime,
          ...this.pagination,
          ...this.query
        }
        this.initPage()
      },

      reset() {
        this.daterange = []
        this.query = {}
        this.pagination = {
          current: 1,
          size: 10,
          total: 0
        }
        this.initPage()
      },

      async initPage() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0]
          endTime = this.daterange[1]
        }
        const params = {
          startTime,
          endTime,
          ...this.pagination,
          ...this.query
        }

        this.loading = true
        const res = await postPrizesPage(params)
        const { code, data } = res
        if (code === 0) {
          this.records = data.records
          this.total = data.total
          this.pagination.total = data.total
        }
        this.loading = false
      }
    }
  }
</script>

<style lang="scss" scoped></style>
